/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const BranchService = {
  async getByName(name) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `Description eq '${name}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCode(code, params) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `Code eq '${code}'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getDefault(params) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `IsDefault eq 'Y'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async getManufactureBranch(params) {
    const requestScreenData = {
      url: "api/Branch",
      filter: `Inactive eq 'N' and ManufactureFlag eq 'Y'`,
      select: ["Code", "Description", "Inactive", "ManufactureFlag", "ManufactureBranchCode"]
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async isBranchManufactureBranch(branchCode) {
    const requestScreenData = {
      url: "api/Branch",
      top: "1",
      filter: `Code eq '${branchCode}' and ManufactureFlag eq 'Y'`,
      select: ["Code"]
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  /**
   * Given a list of candidate branch codes, returns only the ones that exist.
   * Invalid/unrecognized codes are silently dropped from the result.
   */
  async getValidCodes(codes) {
    const safeCodes = (codes || []).filter((code) => /^[A-Za-z0-9]+$/.test(code));

    if (safeCodes.length === 0) return [];

    const filter = safeCodes.map((code) => `Code eq '${code}'`).join(" or ");
    const requestScreenData = {
      url: "api/Branch",
      filter: `(${filter})`,
      select: ["Code"],
    };

    const response = await ApiService.oDataGet(requestScreenData);
    return (response.data.value || []).map((branch) => branch.Code);
  },
};

export { BranchService };
